import { render } from "./ModernGallery.vue?vue&type=template&id=b0c17ef6&scoped=true"
import script from "./ModernGallery.vue?vue&type=script&lang=js"
export * from "./ModernGallery.vue?vue&type=script&lang=js"

import "./ModernGallery.vue?vue&type=style&index=0&id=b0c17ef6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b0c17ef6"

export default script